// views
import { Row, Col } from "antd";

// utils
import moment from "moment";

export default (props) => {
  const { record } = props;

  const formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm");
  };

  return (
    <div className="ele-record">
      <Row
        type="flex"
        justify="space-between"
        gutter={8}
      >
        <Col span={10}>
          <span className="text-break">{record.kind_label}</span>
        </Col>
        <Col span={7}>
          <span>{formatDate(record.created_at)}</span>
        </Col>
        <Col
          span={7}
          className="text-right"
        >
          {record.ele > 0 ? "+" : ""}
          {record.ele}
          <span className={record.ele > 0 ? "up" : "down"} />
        </Col>
      </Row>
      <style jsx>
        {`
          .ele-record {
            background-color: #f7f7f7;
            margin: 5px 0;
            padding: 15px 20px;
            vertical-align: middle;
          }

          .ele-record span {
            line-height: 1;
          }

          .up,
          .down {
            content: " ";
            display: inline-block;
            background-position: right center;
            background-repeat: no-repeat;
            width: 21px;
            height: 20px;
            vertical-align: text-bottom;
          }

          .up {
            background-image: url(/static/icons/arrow-up.svg);
          }

          .down {
            background-image: url(/static/icons/arrow-down.svg);
          }
        `}
      </style>
    </div>
  );
};
